import {IconPopupItem} from "./IconPopupItem";
import ContactsIcon from '@mui/icons-material/Contacts';
import {RouteContact, RouteStop} from "../../../api/Logistics";
import {useState} from "react";
import {Button, IconButton} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import {EditContactTemplate} from "./weekPlanner/EditContactTemplate";
import {api} from "../../../api/API";
import {AskForContractor} from "./AskForContractor";

export function ContactPopup(props: {
    stop: RouteStop;
    value: RouteContact[]
    company?: number;
    project?: number;
    onUpdate(input: RouteStop): Promise<any>
}) {
    return (
        <div style={{paddingLeft: 8}}>
            <IconPopupItem
                icon={<ContactsIcon/>}
            >
                <div style={{padding: 12}}>
                    <ContactInner value={props.value} onUpdate={props.onUpdate} stop={props.stop} company={props.company} project={props.project} />
                </div>
            </IconPopupItem>
        </div>
    )
}

type PromiseObj<T> = {
    resolve(value: T): void;
    reject(err: Error): void;
}

export function ContactInner(props: {
    value: RouteContact[]
    stop: RouteStop;
    onUpdate(input: RouteStop): Promise<any>
    company?: number;
    project?: number;
}) {
    const [editContact, setEditContact] = useState<RouteContact|null>(null);
    const [showCreateContact, setShowCreateContact] = useState(false);
    const [showAskForContactor, setShowAskForContractor] = useState<PromiseObj<number>>();

    const askForContractor = async () => {
        return new Promise<number>((resolve, reject) => {
            setShowAskForContractor({
                resolve,
                reject,
            });
        });
    }

    if(showAskForContactor) {
        const prm = showAskForContactor;
        return <AskForContractor onDone={value => {
            if(!value) {
                prm.reject(new Error("User cancelled"));
                return;
            }

            prm.resolve(value.id);
        }} />
    }

    if(showCreateContact) {
        return (
            <EditContactTemplate
                email=""
                name=""
                phone=""
                title=""
                pmContact={props.project ? false : undefined}
                gcContact={props.project ? true : undefined}
                onClose={() => {
                    setShowCreateContact(false)
                }}
                onUpdate={async input => {
                    if(props.company) {
                        await api.contacts.upsert(Object.assign({}, input, {
                            company: props.company,
                            attrs: {
                                deliveryContact: true,
                            }
                        }));

                        await props.onUpdate(Object.assign({}, props.stop));
                        return;
                    }

                    if(props.project) {
                        const proj = await api.projects.get(props.project);
                        if(!proj.contractor) {
                            proj.contractor = await askForContractor();
                            await api.projects.upsert(proj);
                        }

                        await api.contacts.upsert(Object.assign({}, input, {
                            company: proj.contractor,
                            linkToProject: props.project,
                        }));

                        await props.onUpdate(Object.assign({}, props.stop));
                        return;
                    }

                    if(props.stop.customTextStop !== null && props.stop.customTextStop !== undefined) {
                        const tmpCo = await api.companies.upsert({
                            name: "temp company for route stop #" + props.stop.id,
                            kind: "temporary",
                        });

                        await api.contacts.upsert(Object.assign({}, input, {
                            company: tmpCo.id,
                        }));

                        await props.onUpdate(Object.assign({}, props.stop, {
                            customCompanyForContacts: tmpCo.id,
                        }));

                        return;
                    }

                    throw new Error("invalid state");
                }}
            />
        );
    }

    if(editContact) {
        const ec = editContact;
        return (
            <EditContactTemplate
                email={ec.email}
                name={ec.name}
                phone={ec.phone}
                title={ec.title}
                onClose={() => {
                    setEditContact(null)
                }}
                onDelete={props.stop.customCompanyForContacts ? async () => {
                    const con = await api.contacts.get({id: ec.id});

                    await api.contacts.upsert(Object.assign({}, con, {
                        archived: true,
                    }));

                    await props.onUpdate(Object.assign({}, props.stop));
                } : undefined}
                onUpdate={async input => {
                    const con = await api.contacts.get({id: ec.id});

                    await api.contacts.upsert(Object.assign({}, con, {
                        email: input.email,
                        name: input.name,
                        phone: input.phone,
                        title: input.title,
                    }));

                    await props.onUpdate(Object.assign({}, props.stop));
                }}
            />
        )
    }

    if(props.value.length === 0) return (
        <div>
            <div style={{paddingBottom: 4}}>(None)</div>
            <Button size="small" variant="outlined" onClick={() => {
                setShowCreateContact(true)
            }}>Add Contact</Button>
        </div>
    );
    return <>
        {props.value.map((contact, index) => (
            <>
                <div key={index} style={{
                    paddingTop: 8,
                    paddingBottom: 8,
                    display: "flex",
                    alignItems: "center",
                }}>
                    <div style={{flex: 1, paddingRight: 8}}>
                        <div>{contact.name}</div>
                        <div style={{fontSize: "0.8rem"}}>{contact.title}</div>
                        <div style={{height: 4}} />
                        {contact.phone && <div style={{fontSize: "0.9rem"}}>
                            {contact.phone}
                        </div>}
                        {contact.email && <div style={{fontSize: "0.9rem"}}>
                            <a href={"mailto:" + contact.email}>
                                {contact.email}
                            </a>
                        </div>}
                    </div>
                    <div>
                        <IconButton onClick={() => setEditContact(contact)}>
                            <EditIcon />
                        </IconButton>
                    </div>
                </div>
            </>
        ))}

        <div style={{height: 4}} />
        <Button size="small" variant="outlined" onClick={() => {
            setShowCreateContact(true)
        }}>Add Contact</Button>
    </>
}